<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-row class="fill-height">
						<v-col>
							<v-sheet height="64">
								<v-toolbar flat>
									<v-toolbar-title class="mr-4">Demo</v-toolbar-title>
									<v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Oggi</v-btn>
									<v-btn fab text small color="grey darken-2" @click="prev">
										<v-icon small>mdi-chevron-left</v-icon>
									</v-btn>
									<v-btn fab text small color="grey darken-2" @click="next">
										<v-icon small>mdi-chevron-right</v-icon>
									</v-btn>
									<v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-menu bottom right>
										<template v-slot:activator="{ on, attrs }">
											<v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
												<span>{{ typeToLabel[type] }}</span>
												<v-icon right>mdi-menu-down</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item @click="type = 'day'">
												<v-list-item-title>Giorno</v-list-item-title>
											</v-list-item>
											<v-list-item @click="type = 'week'">
												<v-list-item-title>Settimana</v-list-item-title>
											</v-list-item>
											<v-list-item @click="type = 'month'">
												<v-list-item-title>Mese</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</v-toolbar>
							</v-sheet>
							<v-sheet height="600">
								<v-calendar
									ref="calendar"
									v-model="focus"
									color="primary"
									:events="events"
									:event-color="getEventColor"
									:type="type"
									@click:event="showEvent"
									@click:more="viewDay"
									@click:date="viewDay"
									@change="updateRange"
								></v-calendar>
							</v-sheet>
						</v-col>
					</v-row>
				</v-layout>
			</v-container>
		</v-main>

		<DetailDialog v-model="dialog" :booking="selectedBooking" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import DetailDialog from '@/components/manage/demo/DetailDialog.vue';

const STATUS_COLOR = {
	scheduled: 'green',
	pending: 'orange',
	meet_failed: 'red',
};

export default {
	name: 'ManageDemo',
	components: { DetailDialog },
	data: () => ({
		focus: '',
		type: 'month',
		typeToLabel: {
			month: 'Mese',
			week: 'Settimana',
			day: 'Giorno',
		},
		events: [],
		loading: false,
		dialog: false,
		selectedBooking: null,
	}),
	mounted() {
		if (this.$refs.calendar) this.$refs.calendar.checkChange();
	},
	methods: {
		...mapActions({
			fetchRange: 'calendars/fetchRange',
			destroyData: 'calendars/destroyData',
		}),
		viewDay({ date }) {
			this.focus = date;
			this.type = 'day';
		},
		getEventColor(event) {
			return event.color;
		},
		setToday() {
			this.focus = '';
		},
		prev() {
			this.$refs.calendar.prev();
		},
		next() {
			this.$refs.calendar.next();
		},
		// "HH:mm" + minuti -> "HH:mm" (clamp a 23:59 in caso di overflow)
		addMinutes(slot, minutes) {
			const [h, m] = (slot || '0:0').split(':').map(Number);
			let total = h * 60 + m + minutes;
			if (total > 23 * 60 + 59) total = 23 * 60 + 59;
			const pad = n => String(n).padStart(2, '0');
			return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
		},
		showEvent({ nativeEvent, event }) {
			this.selectedBooking = event.details;
			this.dialog = true;
			nativeEvent.stopPropagation();
		},
		async updateRange({ start, end }) {
			if (!start || !end || !start.date || !end.date) return;
			try {
				this.loading = true;
				const bookings = await this.fetchRange({ start: start.date, end: end.date });
				this.events = (bookings || []).map(b => ({
					name: `${b.slot || ''} ${b.firstName || ''} ${b.lastName || ''}`.trim(),
					start: `${b.date} ${b.slot}`,
					end: `${b.date} ${this.addMinutes(b.slot, 30)}`,
					color: STATUS_COLOR[b.status] || 'blue-grey',
					timed: true,
					details: b,
				}));
			} catch (err) {
				console.log(err);
			} finally {
				this.loading = false;
			}
		},
	},
	beforeDestroy() {
		this.destroyData();
	},
};
</script>
